<div class="backdrop" #backdrop popover="manual">
  <div class="content" [class.loaded]="isLoaded">
    <iframe [src]="url | safe" (load)="onLoad()"></iframe>
    @if (!isLoaded) {
    <spinner></spinner>
    }
  </div>
</div>
